import { FC, ReactNode } from 'react';

interface InlineIconLabelProps {
    icon: ReactNode;
    label: ReactNode;
}

const InlineIconLabel: FC<InlineIconLabelProps> = ({ icon, label }) => (
    <span
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.375rem',
            height: '100%',
            lineHeight: 1,
        }}
    >
        <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 0 }}>
            {icon}
        </span>
        <span style={{ display: 'inline-flex', alignItems: 'center', height: '100%', lineHeight: 1.25 }}>{label}</span>
    </span>
);

export default InlineIconLabel;
